import StarsRating from "./js/StarsRating";

export default StarsRating;
